// extracted by mini-css-extract-plugin
export default {"spinnerScreen":"LoadSpin_spinnerScreen__SH1NN","spinner":"LoadSpin_spinner__Pps2m","spin":"LoadSpin_spin__t9MO1"};